import React from 'react';
//custom component
import { NavBarNew, Footer, MobilePage } from '_molecules';
import { AnimatedAirplanes, TeamMember } from '_atoms';
//bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//media-query
import { useMediaQuery } from 'react-responsive'

// images
import image_conor from "_assets/images/PRM-Logo-PNG/headshot.jpeg";
import image_mo from "_assets/images/PRM-Logo-PNG/mo.png";
import image_halpin from "_assets/images/about/conor-new.jpeg";
import image_rhys from "_assets/images/PRM-Logo-PNG/rhys-image.png";
//#endregion

const AboutUs = () => {
    const isPhone = useMediaQuery({ query: '(max-width: 1224px)' })

    const conorBio = "Personally, I am most interested in the design and creation of our product. My role focuses on the design and implementation of our website and app. I am also involved in product management."
    const moBio = "I primarily work on implementing backend solutions for PRMAssist."
    const halpinBio = "Combining my industry experience with my passion for business and consumer relations, I currently focus on developing and growing our product alongside our customers to ensure a world-class PRM experience."
    const rhysBio = "My experience in the PRM Industry mixed with my background in International Law and Data Privacy gives me a good insight into the level of care and security that should be provided to our customers."

    if (!isPhone) {
        return (
            <div>
                <NavBarNew from={'about-us'} />

                <Container fluid={true} className="d-flex justify-content-center mt-5">
                    <Row>
                        <Col>
                            <h1 className="fw-bold fs-1 mt-5" >The PRM Assist Team.</h1>
                            <p className="fw-lighter fs-4 mt-5"> Our team has years of experience running operations throughout airports globally</p>
                            <p className="fw-lighter fs-4"> Our development team are experts in the latest mobile and web technologies</p>
                        </Col>
                        <Col>
                            <AnimatedAirplanes />
                        </Col>
                    </Row>
                </Container>

                <Container fluid={true} className="justify-content-center">
                    <Col className="flex justify-content-center" style={{ marginLeft: -45 }}>
                        <Container>
                            <TeamMember image={image_halpin} name={'Conor Halpin'} position={"Co-Founder"} bio={halpinBio} />
                            <TeamMember image={image_conor} name={'Conor Thorne'} position={"Lead Developer"} bio={conorBio} />
                            <TeamMember image={image_mo} name={'Mohamed Suliman'} position={"Lead Developer"} bio={moBio} />
                            <TeamMember image={image_rhys} name={'Rhys Costello'} position={"Privacy Officer"} bio={rhysBio} />
                        </Container>
                    </Col>
                </Container>

                <Container fluid={true} className="mt-5 vh-100">
                    <Container className="mt-5">
                        <Row className="mt-5">
                            <Col className="mt-5">
                                <h1 className="fw-bold fs-1 mt-5 text-center" >Our Mission Statement</h1>
                                <p className="fw-lighter fs-2 mt-5 text-center">"To empower people with reduced mobility through new technology, and allow them to take control of their own journeys around the globe"</p>
                                <p className="fw-lighter fs-2">Our Team has passionately worked within the PRM assistance industry for over 30 years combined. During this time we have brought many innovations to which are now globally utilised in regions across the globe</p>
                                <p className="fw-lighter fs-2">The next step on this innovative roadmap was to create the world’s first globally accessible mobile application connected to every airport which allows passengers create, manage and have more control of their journey and have more interactive experiences with the different entities involved in this process. This mobile application has been built in collaboration with our users who will always remain at the core of our business.</p>
                            </Col>
                        </Row>
                    </Container>
                </Container>

                <Footer />
            </div>
        );
    } else {
        return (
            <>
                <NavBarNew from={'about-us'} />
                <MobilePage
                    title="The PRM Assist Team."
                    subtitle="Our team has years of experience running operations throughout airports globally."
                    subsubtitle="Our development team are experts in the latest mobile and web technologies."
                    image={<AnimatedAirplanes />}
                />
                <Container fluid={true} className="mt-5">
                    <Container className="mt-5">
                        <TeamMember image={image_halpin} name={'Conor Halpin'} position={"Co-Founder"} bio={halpinBio} />
                        <TeamMember image={image_conor} name={'Conor Thorne'} position={"Lead Developer"} bio={conorBio} />
                        <TeamMember image={image_mo} name={'Mohamed Suliman'} position={"Lead Developer"} bio={moBio} />
                    </Container>
                </Container>
                <Container fluid={true} style={{ height: '10%' }}>
                    <Container className="">
                        <Row className="mt-5">
                            <Col className="">
                                <h1 className="fw-bold fs-1 mt-4 text-center" >Our Mission Statement</h1>
                                <p className="fw-lighter fs-2 mt-5 text-center">"To empower people with reduced mobility through new technology, and allow them to take control of their own journeys around the globe"</p>
                            </Col>
                        </Row>
                    </Container>
                </Container>
                <Footer />
            </>
        );
    }
}


export default AboutUs;